module.exports = __webpack_public_path__ + "img/kallang (3).05f71ce3.jpg";